






























































































































import moment from 'moment';
import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class extends Vue {
  loading: boolean = false;

  filters: {
    id?: string;
    customer?: string;
    rego?: string;
    dateFrom?: string | null;
    dateTo?: string | null;
    status?: string;
    paymentStatus?: string;
    parked?: boolean | null;
  } = {};

  startDateMenu: boolean = false;
  endDateMenu: boolean = false;
  startDate: string | null = null;
  endDate: string | null = null;

  currentlyParked: boolean = false;

  statusItems: Array<{ text: string; value: string }> = [
    { text: 'Pending', value: 'pending' },
    { text: 'Complete', value: 'complete' },
    { text: 'Cancelled', value: 'cancelled' },
    { text: 'Abandoned', value: 'abandoned' },
    { text: 'Error', value: 'error' },
    { text: 'Payment failed', value: 'payment_failed' },
  ];

  paymentStatusItems: Array<{ text: string; value: string }> = [
    { text: 'Paid', value: 'paid' },
    { text: 'Unpaid', value: 'unpaid' },
    { text: 'Refunded', value: 'refunded' },
  ];

  get formattedStartDate() {
    if (!this.startDate) {
      return '';
    }
    return moment(this.startDate, 'YYYY-MM-DD').format('D/M/YYYY');
  }
  set formattedStartDate(d) {
    if (d === null) {
      this.startDate = null;
    }
  }

  get formattedEndDate() {
    if (!this.endDate) {
      return '';
    }
    return moment(this.endDate, 'YYYY-MM-DD').format('D/M/YYYY');
  }
  set formattedEndDate(d) {
    if (d === null) {
      this.endDate = null;
    }
  }

  save() {
    if (this.startDate) {
      this.filters.dateFrom = moment(
        this.startDate,
        'YYYY-MM-DD',
      ).toISOString();
    } else {
      this.filters.dateFrom = null;
    }
    if (this.endDate) {
      this.filters.dateTo = moment(this.endDate, 'YYYY-MM-DD')
        .add(1, 'day')
        .subtract(1, 'millisecond')
        .toISOString();
    } else {
      this.filters.dateTo = null;
    }
    this.filters.parked = this.currentlyParked || null;
    this.$emit('do-filter', this.filters);
  }
}
